<template>
  <div class="file-detail">
    <div class="detail-name">
      <svg-icon cls="type-icon" :icon="iconImg" />
      <span class="file-rename-name ellipsis" :title="cardData.name" @click="showDetail">{{isSearch ? cardData.showName : cardData.name}}</span>
    </div>
    <div class="detail-item">
      <span>发表机构</span>
      <p>{{cardData.creator && cardData.creator.user_name}}</p>
    </div>
    <div class="detail-item">
      <span>最新更新</span>
      <p>{{updateTime}}</p>
    </div>
    <div class="detail-item">
      <span>浏览数</span>
      <p>{{cardData.read_num}}</p>
    </div>
    <div class="tags" v-show="cardData.tags && cardData.tags.length">
      <span class="tag-item" v-for="(item, index) in cardData.tags" :key="index">{{item.name}}</span>
    </div>
  </div>
</template>
<script>
import dataHandler from '../dataHandler'
import SvgIcon from '../../utils/SvgIcon'
import { formatDate } from '@/utils/common'
export default {
  name: 'FileDetail',
  props: {
    cardData: {
      type: Object,
      default: () => ({})
    }
  },
  components: {
    SvgIcon
  },
  data () {
    return {
      newCardData: {}
    }
  },
  computed: {
    iconImg () {
      return dataHandler.getIcon(this.cardData.extension || (this.cardData.isFolder || this.cardData.type === 'folder' ? 'folder' : 'default'))
    },
    updateTime () {
      return formatDate(this.cardData.updated * 1000, '%YY-%MM-%DD')
    }
  },
  mounted () {

  },
  methods: {

  }
}
</script>
<style lang="postcss" scoped>
  .file-detail {
    display: flex;
    flex-direction: column;
    width: 100%;
    padding-left: 14px;
    box-sizing: border-box;

    & .margin-left-8 {
      margin-left: 8px;
    }

    & .type-icon {
      width: 30px;
      height: 30px;
      border-radius: 4px;
      margin-right: 16px;
    }

    & .detail-name {
      display: flex;
      justify-content: flex-start;
      align-items: center;
    }

    & .detail-item {
      display: flex;
      align-items: center;
      margin-top: 4px;

      & span {
        width: 78px;
        margin-right: 10px;
        color: #9BA7BA;
        font-family: "PingFang SC";
        font-size: 12px;
        font-style: normal;
        font-weight: 400;
        line-height: 20px;
      }

      & p {
        color: #626F84;
        font-family: "PingFang SC";
        font-size: 12px;
        font-style: normal;
        font-weight: 400;
        line-height: 20px;
      }

      &:first-child {
        margin-top: 12px;
      }
    }

    & .tags {
      display: flex;
      flex-wrap: wrap;

      & .tag-item {
        display: inline-flex;
        align-items: center;
        height: 20px;
        padding: 0 8px;
        align-items: center;
        border-radius: 4px;
        background: #EBF4FF;
        color: #0050A1;
        font-family: "PingFang SC";
        font-size: 10px;
        font-style: normal;
        font-weight: 400;
        line-height: 16px;
        box-sizing: border-box;
        margin-right: 8px;
        margin-top: 8px;
      }
    }
  }
</style>
